import aboutImageUrl from "@/assets/images/sobre-tutor-cao.jpg"
import { useSiteContent } from "@/shared/content/SiteContentProvider"
import { BrandSymbol } from "@/shared/ui/BrandSymbol"
import { Section } from "@/shared/ui/Section"
import { SectionHeading } from "@/shared/ui/SectionHeading"

export function AboutSection() {
  const { brandValues } = useSiteContent()

  return (
    <Section id="sobre" tone="off-white">
      <div className="grid lg:grid-cols-2 gap-6 sm:gap-10 lg:gap-20 items-center">
        {/* ── Foto ────────────────────────────────────────────────────────── */}
        <div className="relative order-2 lg:order-1">
          <div className="relative rounded-[32px] overflow-hidden aspect-[4/5] max-w-md mx-auto lg:mx-0">
            <img
              src={aboutImageUrl}
              alt="Tutor com seu cão, representando o cuidado e a confiança propostos pela DIMPET"
              loading="lazy"
              decoding="async"
              className="w-full h-full object-cover"
              style={{ filter: "saturate(0.95) brightness(0.98)" }}
            />
            <div
              className="absolute inset-0"
              style={{ background: "linear-gradient(160deg, rgba(46,55,36,0.12) 0%, transparent 60%)" }}
              aria-hidden="true"
            />
            <BrandSymbol className="absolute top-6 left-6 w-10 h-10 text-white opacity-15" />
          </div>

          <div
            className="absolute -bottom-6 -right-6 w-40 h-40 rounded-full border-2 border-dourado/20 pointer-events-none"
            aria-hidden="true"
          />
          <div
            className="absolute -top-4 -left-4 w-20 h-20 rounded-full bg-verde-profundo/6 pointer-events-none"
            aria-hidden="true"
          />
        </div>

        {/* ── Texto ───────────────────────────────────────────────────────── */}
        <div className="flex flex-col gap-8 order-1 lg:order-2">
          <SectionHeading
            eyebrow="Sobre a DIMPET"
            title="Saúde preventiva para quem faz parte da família"
            description="A DIMPET Saúde Preventiva nasce com o propósito de aproximar tutores e serviços veterinários, estimulando o acompanhamento responsável da saúde de cães e gatos."
          />

          <div className="flex flex-col gap-4">
            <p className="text-xs font-semibold tracking-widest uppercase text-verde-profundo/40">
              Nossos valores
            </p>

            <ul className="flex flex-col gap-3">
              {brandValues.map((value, index) => (
                <li key={value.label} className="flex gap-4 items-start">
                  <div
                    className="shrink-0 w-6 h-6 rounded-full bg-dourado/12 flex items-center justify-center mt-0.5"
                    aria-hidden="true"
                  >
                    <span className="text-[10px] font-bold text-dourado-escuro">{index + 1}</span>
                  </div>
                  <div>
                    <p className="font-semibold text-verde-profundo text-sm leading-snug">{value.label}</p>
                    <p className="text-sm text-verde-profundo/55 leading-relaxed mt-0.5">{value.description}</p>
                  </div>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </Section>
  )
}
